// extracted by mini-css-extract-plugin
export default {"modal":"GO-z","modalOverlay":"HO-z","outfitHeading":"IO-z"};